import route from "ziggy-js"
import { api } from "@/api"
import { defineStore } from "pinia"
import { ref } from "vue"

export const useSchools = defineStore("schools", () => {
  const loading = ref(false)
  const schools = ref([])

  if (!loading.value) {
    api.schoolList().then(({ data }) => {
      data.forEach(school => {
        schools.value.push({ ...school, url: route("schools.show", school) })
      })
    })

    loading.value = true
  }

  return { loading, schools }
})
